var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.91797 10.7508H7.58464L4.9888 12.4775C4.6038 12.7342 4.08464 12.46 4.08464 11.9933V10.7508C2.33464 10.7508 1.16797 9.58415 1.16797 7.83415V4.33415C1.16797 2.58415 2.33464 1.41748 4.08464 1.41748H9.91797C11.668 1.41748 12.8346 2.58415 12.8346 4.33415V7.83415C12.8346 9.58415 11.668 10.7508 9.91797 10.7508Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99566 7.06445C6.75649 7.06445 6.55816 6.86612 6.55816 6.62695V6.50448C6.55816 5.82781 7.05398 5.4953 7.24065 5.36697C7.45648 5.22114 7.52648 5.12197 7.52648 4.97031C7.52648 4.67864 7.28733 4.43945 6.99566 4.43945C6.70399 4.43945 6.46484 4.67864 6.46484 4.97031C6.46484 5.20947 6.26651 5.40781 6.02734 5.40781C5.78818 5.40781 5.58984 5.20947 5.58984 4.97031C5.58984 4.19447 6.21983 3.56445 6.99566 3.56445C7.77149 3.56445 8.40148 4.19447 8.40148 4.97031C8.40148 5.63531 7.9115 5.9678 7.73067 6.0903C7.50317 6.24196 7.43316 6.34114 7.43316 6.50448V6.62695C7.43316 6.87195 7.23483 7.06445 6.99566 7.06445Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5166C6.755 8.5166 6.5625 8.31827 6.5625 8.0791C6.5625 7.83993 6.76083 7.6416 7 7.6416C7.23917 7.6416 7.4375 7.83993 7.4375 8.0791C7.4375 8.31827 7.245 8.5166 7 8.5166Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e016cac91e45e3d005dc062c134430c1.svg";
export { ForwardRef as ReactComponent };